let PackagesItem = [
    {
        trackTitle: "FULL Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "500",
        // trackFullPrice: '500',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1668432071560x390252042156245000',
        // earlyBird: true,
        trackJunior: true,
    },
    {
        trackTitle: "Career Track",
        trackJunior: true,
        trackSubtitle: "For Junior specialists",
        trackPrice: "0",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticketfree/1668430314824x722346821798330400',
        earlyBird: true,
    },
    {
        trackTitle: "2 Software Development Events",
        event1: "Worldwide Software Architecture Summit'23",
        event2: "AI in Software Architecture Conference'23",
        event2Link: "https://events.geekle.us/aiarchitecture/",
        trackPrice: "599",
        trackFullPrice: '1000',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: '2 Live events + Recordings',
        trackLink: 'https://geekle.us/ticket/1682336905912x443558826323476500',
    },
    {
        trackTitle: "Year of Software Architecture Events",
        year: "Full Access to the live stream and recordings for 4 events in the Software Architecture domain",
        trackPrice: "649",
        trackFullPrice: '1200',
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Live event + Recordings',
        trackLink: 'https://geekle.us/ticket/1683107840710x122889343632408580',
    },
];

export default PackagesItem;
